var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"80vh","width":"100%","align":"center"}},[_c('h1',{staticStyle:{"font-size":"30px","margin":"0 40%"}},[_vm._v("中国电影翻译史")]),_c('span',{staticStyle:{"font-size":"20px","margin":"0 40%"}},[_vm._v("外译库"+_vm._s(_vm.count)+"条")]),_c('svg',{attrs:{"id":"time","height":"100%","width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }